/**
 * @prettier
 */

import React, { useContext, useEffect, useState } from 'react'

import AuthContext from '../../context/auth/AuthContext'
import HomeContext from '../../context/home/HomeContext'

import { useFormHandler } from '../../utils/Custom'

import CategoryListPage from '../ui/CategoryListPage'
import { CardContainer, ListContainer } from '../layout/Containers'
import { PlusIcon } from '../../img/images'
import Drawer from '../input/Drawer'
import CategoryListCollectionRefactor from '../ui/CategoryListCollectionRefactor'
import { withComponentLabel } from '../../utils/debug'

const HomesPage = () => {
  const homeContext = useContext(HomeContext)
  const authContext = useContext(AuthContext)

  const { getHomes, addHome, clearCurrentHome } = homeContext
  const { loadUser } = authContext

  const [loading, setLoading] = useState(true)
  const [theseHomes, setTheseHomes] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)

  useEffect(() => {
    const loadHomesList = async () => {
      await loadUser()
      const homes = await getHomes()
      console.log('homes', typeof homes)
      setTheseHomes(homes)
      clearCurrentHome()
      setShowDrawer(false)
      setLoading(false)
    }

    loadHomesList()
    // eslint-disable-next-line
  }, [])

  const [changeVal, submitVal, state] = useFormHandler(addHome, { name: '' })

  const homeAdd = async () => {
    setLoading(true)
    const newHome = await submitVal(state)
    setTheseHomes((prevState) => [...prevState, newHome])
    changeVal({ name: '' })
    setLoading(false)
  }

  const onChange = (e) => {
    e.preventDefault()
    changeVal({ [e.target.name]: e.target.value })
  }

  const handleModalClick = () => {
    setShowDrawer(!showDrawer)
  }

  const addIcon = (
    <PlusIcon
      color="fill-gray-700"
      height="9"
      width="9"
    />
  )

  return (
    <ListContainer>
      <CardContainer>
        {!loading && (
          <>
            {console.log('theseHomes', theseHomes)}
            <CategoryListPage
              model={theseHomes}
              headerString="Homes"
            >
              <Drawer
                addIcon={addIcon}
                handleButtonClick={handleModalClick}
                display={showDrawer}
                action={homeAdd}
                onChange={onChange}
                placeholder="New home name"
              />
              <CategoryListCollectionRefactor
                type="homes"
                collection={theseHomes}
              />
            </CategoryListPage>
          </>
        )}
      </CardContainer>
    </ListContainer>
  )
}

export default withComponentLabel(HomesPage, 'HomesPage')
